import { momentLocalizer } from 'react-big-calendar'

import moment from 'moment'

const localizer = momentLocalizer(moment)
localizer.formats.yearHeaderFormat = 'YYYY'

export default localizer
